import type { ReactNode } from 'react';
import { Flex, Box } from '@radix-ui/themes';
import type { AnimationStyle } from '@/ui/icons/dutchie-icon';
import { DutchieIcon } from '@/ui/icons/dutchie-icon';

interface AgentMessageLayoutProps {
  animateIcon?: boolean | AnimationStyle;
  children: ReactNode;
}

export function AgentMessageLayout({ animateIcon = false, children }: AgentMessageLayoutProps) {
  return (
    <Flex gap="3" align="start" style={{ alignSelf: 'flex-start', maxWidth: '90%' }}>
      <Flex flexShrink="0" align="center" justify="center">
        <DutchieIcon size={18} animate={animateIcon} />
      </Flex>
      <Box style={{ minWidth: 0, flex: 1 }}>{children}</Box>
    </Flex>
  );
}
